<script>
  import AdminAction from './AdminAction.svelte';
  import ConfirmModal from '../common/ConfirmModal.svelte';
  import Common from '../js/common.js';

  export let value;
  export let dark = false;
  export let lang = undefined;
  export let admin;

  let displayConfirmModal = false;
  let confirmModalMessage;
  let messageBox;

  async function deleteTweet () {
    messageBox = {
      cs: { color: 'blue', message: i18n.deletingInProgress.cs },
      en: { color: 'blue', message: i18n.deletingInProgress.en },
    };

    // eslint-disable-next-line no-undef
    const response = await fetch(`${Common.BACKEND_URL}/admin/tweets/delete/${value.id}`);

    if (response.ok) {
      window.location.reload();
    } else {
      messageBox = {
        cs: { color: 'red', message: i18n.unexpectedError.cs },
        en: { color: 'red', message: i18n.unexpectedError.en },
      };
    }
  }

  $: if (admin) {
    confirmModalMessage = {
      cs: `Opravdu chcete smazat tweet "[${Common.addZeros(value.id)}]"?`,
      en: `Do you really want to delete tweet "[${Common.addZeros(value.id)}]"?`,
    };
  }

  const i18n = {
    edit: {
      cs: 'Upravit',
      en: 'Edit',
    },
    delete: {
      cs: 'Smazat',
      en: 'Delete',
    },
    deletingInProgress: {
      cs: 'Probíhá mazání článku...',
      en: 'Article deleting in progress...',
    },
    unexpectedError: {
      cs: '(Ne)očekávaná chyba. `E29`',
      en: '(Un)expected error. `E29`',
    },
  };
</script>

<div class='tweet'>
  <div class='tweet-box' class:tweet-box-dark={dark}>
    {#if admin}
      <div class='tweet-box-admin'>
        <AdminAction value={i18n.edit[lang]} icon='edit'
          onClick={() => { window.location.href = `./#/admin/tweets/${value.id}`; }}/>

        <AdminAction value={i18n.delete[lang]} icon='delete'
          onClick={() => { displayConfirmModal = true; }}/>
      </div>
    {/if}

    <div class='tweet-box-content'>
      {@html Common.escapeMarkdown(value.content[lang])}

      <div class='tweet-box-content-gradient'/>
    </div>

    <div class='tweet-box-hashtag-and-date'>
      <div class='tweet-box-hashtag-and-date-hashtag'> #{value.hashtag} </div>
      <div class='tweet-box-hashtag-and-date-date'> {Common.convertDbDate(value.timestamp)} </div>
    </div>
  </div>
</div>

{#if admin}
  <ConfirmModal bind:display={displayConfirmModal} message={confirmModalMessage[lang]}
    onConfirm={deleteTweet} messageBox={messageBox ? messageBox[lang] : undefined} bind:lang/>
{/if}

<style>
  .tweet {
    width: 100%;

    z-index: 1;
  }

  .tweet-box {
    display: flex;
    flex-direction: column;

    padding: 20px;

    border-radius: 5px;

    background: var(--grey-1);
  }

  .tweet-box-admin {
    display: flex;
    justify-content: space-between;

    margin-bottom: 20px;
  }

  .tweet-box-content {
    position: relative;

    height: 112.5px;

    overflow: hidden;
    overflow-wrap: anywhere;
  }

  .tweet-box-content-gradient {
    position: absolute;
    bottom: 0px;

    width: 100%;
    height: 20px;

    background: linear-gradient(rgba(245, 245, 245, 0), rgba(245, 245, 245, 1) 87.5%);
  }

  .tweet-box-hashtag-and-date {
    display: flex;
    justify-content: space-between;
    align-items: center;

    height: 22.5px;
  }

  .tweet-box-hashtag-and-date-hashtag {
    font-weight: 550;

    color: var(--tertiary);
  }

  .tweet-box-hashtag-and-date-date {
    color: var(--grey-7);
  }

  .tweet-box-dark {
    background: var(--grey-3);
  }

  .tweet-box-dark .tweet-box-content-gradient {
    background: linear-gradient(rgba(224, 224, 224, 0), rgba(224, 224, 224, 1) 87.5%);
  }

  :global(body.dark) .tweet-box {
    background: var(--grey-8);
  }

  :global(body.dark) .tweet-box-content-gradient {
    background: linear-gradient(rgba(66, 66, 66, 0), rgba(66, 66, 66, 1) 87.5%);
  }

  :global(body.dark) .tweet-box-hashtag-and-date-date {
    color: var(--grey-5);
  }

  :global(body.dark) .tweet-box-dark {
    background: var(--grey-7);
  }

  :global(body.dark) .tweet-box-dark .tweet-box-content-gradient {
    background: linear-gradient(rgba(97, 97, 97, 0), rgba(97, 97, 97, 1) 87.5%);
  }
</style>
